window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['productForm']) return;

  function productForm(data = {}) {
    return {
      ...data,

      isLoadingProductForm: false,

      get formData() {
        var formData = new FormData(this.$el);

        formData.set('sections', this.$store.cart.sectionIds);

        return formData;
      },

      init() {
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.selectedOptionValues = this.getSelectedOptionValues();
        this.selectedSellingPlanId = this.getSelectedSellingPlanId();

        this.$el.addEventListener('change', this.onChange);
        this.$el.addEventListener('submit', this.onSubmit);
      },

      destroy() {
        this.$el.removeEventListener('change', this.onChange);
        this.$el.removeEventListener('submit', this.onSubmit);
      },

      onChange(event) {
        var optionInputAll = this.getOptionInputElAll();

        var sellingPlanInput = this.sellingPlanInputEl();

        if ([...optionInputAll, sellingPlanInput].includes(event.target)) {
          this.selectedOptionNames = this.getSelectedOptionNames();
          this.selectedOptionValues = this.getSelectedOptionValues();
          this.selectedSellingPlanId = this.getSelectedSellingPlanId();

          dispatchEvent(new CustomEvent('productformchange', {
            detail: {
              selectedOptionValues: this.selectedOptionValues,
              selectedSellingPlanId: this.selectedSellingPlanId
            }
          }));
        }
      },

      getOptionInputElAll() {
        return this.$el.querySelectorAll('[x-ref="optionInput"]')
      },

      sellingPlanInputEl() {
        return this.$el.querySelector('[x-ref="sellingPlanInput"]')
      },

      getSelectedOptionInputEls() {
        var optionInputAll = this.getOptionInputElAll();

        return [...optionInputAll]
          .filter((optionInputEl) => optionInputEl.checked || optionInputEl.tagName == 'SELECT')
          .map((optionInputEl) => {
            if (optionInputEl.tagName == 'SELECT') {
              return optionInputEl.selectedOptions[0];
            }

            return optionInputEl;
          });
      },

      getSelectedOptionNames() {
        return this.getSelectedOptionInputEls().map((optionInputEl) => optionInputEl.value);
      },

      getSelectedOptionValues() {
        return this.getSelectedOptionInputEls().map((optionInputEl) => +(optionInputEl.dataset.optionValueId));
      },

      getSelectedSellingPlanId() {
        return this.formData.get('selling_plan');
      },

      onSubmit(event) {
        event.preventDefault();

        if (this.isLoadingProductForm) return;

        dispatchEvent(new CustomEvent('productformsubmitstart', { detail: { showModal: this.showModal } }));
        dispatchEvent(new CustomEvent('cartchangestart', { detail: { showModal: this.showModal } }));

        this.isLoadingProductForm = true;

        var fetchUrl = this.$el.action;

        var fetchOptions = {
          method: this.$el.method,
          body: this.formData,
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              return res.text().then((err) => { throw new Error(err) });
            }

            return res.json();
          })
          .then((res) => {
            dispatchEvent(new CustomEvent('productformsubmitsuccess', { detail: { res } }));
            dispatchEvent(new CustomEvent('cartchangesuccess', { detail: { res } }));
          })
          .catch((err) => {
            dispatchEvent(new CustomEvent('productformsubmiterror', { detail: { err } }));
            dispatchEvent(new CustomEvent('cartchangeerror', { detail: { err } }));
            console.log(err);
          })
          .finally(() => {
            dispatchEvent(new CustomEvent('productformsubmitend'));
            dispatchEvent(new CustomEvent('cartchangeend'));
            this.isLoadingProductForm = false;
          });
      }
    };
  };

  Alpine.data('productForm', productForm);

  window.global.registeredAlpineComponents['productForm'] = true;
});
